import React, { Component } from "react";
import CardBlock from "./../Nano/CardBlock";

class MappingListOutput extends Component {
  constructor(props) {
    super(props);
  }

  isSelected = (item) => {
    if (this.props.selectable && this.props.selectedIds) {
      let selected = this.props.selectedIds.includes(item.idProgram);
      switch (this.props.selectMode) {
        case "Exclude":
          return !selected;
        case "Include":
          return selected;
      }
    }
    return false;
  };

  render() {
    if (!this.props.data) return;

    return this.props.data.map((obj, objIndex) => (
      <section key={this.props.isLoadingDone ? objIndex : obj.idProgram}>
        <CardBlock
          isLoadingDone={this.props.isLoadingDone}
          id={obj.idProgram}
          title={obj.localTitle}
          countryAndChannel={obj.country === null || obj.channel === null ? null : `${obj.country} - ${obj.channel}`}
          genre={obj.genre}
          subGenre={obj.subGenre}
          date={obj.date}
          image={obj.image}
          performanceColor={obj.premiereColor}
          isNotaSelection={obj.isNotaSelection}
          isNew={obj.isNew}
          size={this.props.cardsLength === 6 ? "xxs" : "xs"}
          type={this.props.type}
          selectable={this.props.selectable}
          selected={this.isSelected(obj)}
          onSelectedChange={(selected) => {
            if (this.props.onSelectedChange) {
              this.props.onSelectedChange({ idProgram: obj.idProgram, selected: selected });
            }
          }}
          hasBiggerThumb={true}
          hideSelection={this.props.hideSelection}
        />
      </section>
    ));
  }
}

export default MappingListOutput;

// --- // Documentation // --- //
/*
import MappingListOutput from './../Micro/MappingListOutput.js';

<MappingListOutput
    data={null}
    isLoadingDone={false}
/>
*/
